import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'

class ConfigModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fullName: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.setState({ fullName: event.target.value })
  }

  setConfig() {
    // TODO import risks and users and build an object to update the firebase state
  }

  render() {
    const actions = [
      <FlatButton
        label='Cancel'
        primary={true}
        onTouchTap={this.props.signOut}
      />,
      <FlatButton
        label='Save'
        primary={true}
        onTouchTap={this.updateConfig}
      />
    ]

    return (
      <Dialog
        title='First Time Setup'
        actions={actions}
        modal={true}
        open={true}
      >
        <p>Hey there! Looks like it's your first time here so let's get you set up.</p>
        <p>What should we call you for this demo?</p>
        <TextField
          floatingLabelText='Your Name'
          fullWidth={true}
          onChange={this.handleChange}
          value={this.state.fullName}
          type='text'
        />
      </Dialog>
    )
  }
}

export default ConfigModal



// WEBPACK FOOTER //
// ./src/components/ConfigModal.js